import { Pressable, View, Text } from "react-native";
import clsx from "clsx";
import { RoomModel } from "app/services/api/types/locations/models/RoomModel";
import { useRef, useState } from "react";
import { ActionPopupMenu } from "../../../components/molecules/ActionPopupMenu";
import { Icon, ThreeDotsIcon } from "ui/gluestack/icon";

interface Props {
  room: RoomModel & { startEditing?: boolean };
  currentSelectedRoom?: number;
  onRoomSelected: () => void;
  onEditRoom: () => void;
  onDeleteRoom: () => void;
}

export function EditableFormRoomDetails({
  room,
  onRoomSelected,
  currentSelectedRoom,
  onEditRoom,
  onDeleteRoom,
}: Props) {
  const [showMenu, setShowMenu] = useState(false);
  const menuIconRef = useRef<View>(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const openMenu = () => {
    menuIconRef.current?.measure((_fx, _fy, _width, height, px, py) => {
      setMenuPosition({ top: py + height, left: px });
      setShowMenu(true);
    });
  };

  const menuActions = [
    { title: "Edit room details", onPress: onEditRoom },
    { title: "Delete room", onPress: onDeleteRoom },
  ];

  const handleRoomSelected = () => {
    onRoomSelected();
  };
  return (
    <Pressable
      onPress={handleRoomSelected}
      onLongPress={onEditRoom}
      className={clsx(
        "flex-1 flex-row py-4 pl-4 m-2 rounded-sm",
        room.id === currentSelectedRoom && room.id !== undefined
          ? "bg-secondary-0"
          : "bg-transparent",
      )}
    >
      <View className="flex-1 mr-5">
        <View className="flex lg:flex-row justify-between gap-x-3 mb-3">
          <Text className="font-semibold">{room.name}</Text>
          <Text>{room.room_number}</Text>
        </View>
        <Text>{room.description}</Text>
      </View>

      <Pressable ref={menuIconRef} onPress={openMenu}>
        <Icon as={ThreeDotsIcon} className={"rotate-90"} />
      </Pressable>

      <ActionPopupMenu
        visible={showMenu}
        onClose={() => setShowMenu(false)}
        position={menuPosition}
        actions={menuActions}
      />
    </Pressable>
  );
}
